import { Container, Row, Col, Image } from 'react-bootstrap'
import Link from 'next/link'
import { useState, useEffect } from 'react'
import { ModalWhyDoWeAge, ModalWhatVitAndMinDo, ModalWhySupplementationImpt, ModalTheVitaminChecklist } from '../Block'
import Cookies from 'universal-cookie';
import { Request } from '@group-devs/yfp7-global-modules'

const request = new Request(process.env.apiDomain)

function TourContent (props) {

    const accountId = props.site.site.accountId

    const { data: info } = request.account.swrAccountProfileData(accountId, "account_user_trial_info");
    const config = info && info.data ? JSON.parse(info.data) : ''
    const companyName = config ? config.company_name : '';

    const [ModalWhyDoWeAgeShow, setModalWhyDoWeAgeShow] = useState(false);
    const [ModalWhatVitAndMinDoShow, setModalWhatVitAndMinDoShow] = useState(false);
    const [ModalWhySupplementationImptShow, setModalWhySupplementationImptShow] = useState(false);
    const [ModalTheVitaminChecklistShow, setModalTheVitaminChecklistShow] = useState(false);
    
    const host = props.site.host;

    const [video1, setVideo1] = useState('')
    const [video2, setVideo2] = useState('')
    const [video3, setVideo3] = useState('')
    const [video4, setVideo4] = useState('')

    useEffect(() => {
        const cookies = new Cookies();

        setVideo1(cookies.get('video1'))
        setVideo2(cookies.get('video2'))
        setVideo3(cookies.get('video3'))
        setVideo4(cookies.get('video4'))

    }, [])

    return (
        <>
        <div className="section-discover-tour-content">
            <Container>
                <div className="discover-timeline">
                    <div className="module">
                        <span className="box1">&nbsp;</span>
                        <span className={`circle1 ${video1} `} id="video-tour-2">&nbsp;</span>
                        <a onClick={() => setModalWhyDoWeAgeShow(true)} className="text-link2">
                            <Row>
                                <Col lg={{span:8, order:2}} md={{span:7, order:2}}>
                                    <h4><strong>Why Do We Age and Get Sick?</strong></h4>
                                    <p>We don’t actually age, get sick and get diseases - our cells do.<br/>
                                        Our body’s health is dependent on our cells' health.</p>
                                    <p>3:07 mins</p>
                                </Col>
                                <Col lg={{span:4, order:1}} md={{span:5, order:1}}>
                                    <p><Image src="../images/discover/img-video-why-do-we-age01.jpg" alt="Why Do We Age and Get Sick?" className="img-fluid d-block mx-md-auto"/></p>
                                </Col>
                            </Row>
                        </a>
                    </div>
                    <div className="module">
                        <span className={`circle1 ${video2} `} id="video-tour-3">&nbsp;</span>
                        <a onClick={() => setModalWhatVitAndMinDoShow(true)} className="text-link2">
                            <Row>
                                <Col lg={{span:8, order:2}} md={{span:7, order:2}}>
                                    <h4><strong>What Do Vitamins And Minerals Do?</strong></h4>
                                    <p>Where do vitamins and minerals come from?<br/>
                                        Learn the fundamentals in this short video.</p>
                                    <p>2:55 mins</p>
                                </Col>
                                <Col lg={{span:4, order:1}} md={{span:5, order:1}}>
                                    <p><Image src="../images/discover/img-video-what-do-vitamins-and-minerals-do01.jpg" alt="What Do Vitamins And Minerals Do?" className="img-fluid d-block mx-md-auto"/></p>
                                </Col>
                            </Row>
                        </a>
                    </div>
                    <div className="module">
                        <span className={`circle1 ${video3} `}id="video-tour-3">&nbsp;</span>
                        <a onClick={() => setModalWhySupplementationImptShow(true)} className="text-link2">
                            <Row>
                                <Col lg={{span:8, order:2}} md={{span:7, order:2}}>
                                    <h4><strong>Why Supplementation is Important</strong></h4>
                                    <p>Since your body cannot manufacture most vitamins on its own, they can come only from the food you eat and the supplements you take every day.</p>
                                    <p>4:26 mins</p>
                                </Col>
                                <Col lg={{span:4, order:1}} md={{span:5, order:1}}>
                                    <p><Image src="../images/discover/img-video-why-supplementation-is-important01.jpg" alt="Why Supplementation is Important" className="img-fluid d-block mx-md-auto"/></p>
                                </Col>
                            </Row>
                        </a>
                    </div>
                    {
                      companyName === 'Shaklee' && (
                        <div className="module">
                          <span className={`circle1 ${video4}`} id="video-tour-3">&nbsp;</span>
                          <a onClick={() => setModalTheVitaminChecklistShow(true)} className="text-link2">
                            <Row>
                              <Col lg={{ span: 8, order: 2 }} md={{ span: 7, order: 2 }}>
                                <h4><strong>The Vitamin Checklist</strong></h4>
                                <p>This video will ensure you know the right questions to ask when choosing your next vitamin supplement.</p>
                                <p>7:28 mins</p>
                              </Col>
                              <Col lg={{ span: 4, order: 1 }} md={{ span: 5, order: 1 }}>
                                <p><Image src="../images/discover/img-video-the-vitamin-checklist01.jpg" alt="The Vitamin Checklist" className="img-fluid d-block mx-md-auto" /></p>
                              </Col>
                            </Row>
                          </a>
                        </div>
                      )
                    }

                    <div className="module">
                        <h4><strong>Want to Discover More?</strong></h4>
                        <p>If you'd like to discover how to create vitality for life and thrive using <br className="d-md-block d-none"/>
                            our favorite wellness brand, click below to continue your tour.</p>
                    </div>
                    <div className="module take-tour-btn-container">
                        <Image src="../images/discover/img-arrow03.png" alt="" className="arrow1"/>
                        <p><Link href={'http://'+host} passHref><a className="btn btn-lg btn1">Continue Tour</a></Link></p>
                    </div>
                </div>
            </Container>
        </div>
        <ModalWhyDoWeAge show={ModalWhyDoWeAgeShow} onHide={() => setModalWhyDoWeAgeShow(false)}/>
        <ModalWhatVitAndMinDo show={ModalWhatVitAndMinDoShow} onHide={() => setModalWhatVitAndMinDoShow(false)}/>
        <ModalWhySupplementationImpt show={ModalWhySupplementationImptShow} onHide={() => setModalWhySupplementationImptShow(false)}/>
        <ModalTheVitaminChecklist show={ModalTheVitaminChecklistShow} onHide={() => setModalTheVitaminChecklistShow(false)}/>
        <style jsx global>{`

                .section-discover-tour-content {
                    font-size: 18px;
                    line-height: 30px;
                    color: #1b1b1b;
                }

                .section-discover-tour-content .container {
                    padding-left: 30px;
                    padding-bottom: 100px;
                }

                .section-discover-tour-content .discover-timeline {
                    border-left: 4px solid #484848;
                }

                .section-discover-tour-content .module {
                    padding-left: 50px;
                    position: relative;
                    margin-bottom: 30px;
                }

                .section-discover-tour-content .module h3 {
                    line-height: 1.5;
                }

                .section-discover-tour-content .module h4 {
                    font-size: 18px;
                    margin-top: 10px;
                }

                .section-discover-tour-content .module .arrow1 {
                    position: absolute;
                    left: -4px;
                    top: 24px;
                    background: #fff;
                    z-index: 2;
                    padding-bottom: 140px;
                }

                .section-discover-tour-content .module .box1 {
                    position: absolute;
                    left: -14px;
                    top: -7px;
                    background: #fff;
                    width: 24px;
                    height: 100px;
                    z-index: 2;
                }

                .section-discover-tour-content .module .circle1 {
                    position: absolute;
                    left: -14px;
                    top: 70px;
                    background: #fff;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    z-index: 2;
                    border: 4px solid rgba(67,166,73,1.00);
                }

                .section-discover-tour-content .module .circle1.done {
                    background: rgba(67,166,73,1.00);
                    border: 2px solid rgba(67,166,73,1.00);
                }

                .section-discover-tour-content .module .circle2 {
                    position: absolute;
                    left: -14px;
                    top: 70px;
                    background: #fff;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    z-index: 2;
                    border: 4px solid rgba(67,166,73,1.00);
                }

                .section-discover-tour-content .module .circle2.done {
                    background: rgba(67,166,73,1.00);
                    border: 2px solid rgba(67,166,73,1.00);
                }

                .section-discover-tour-content .module .circle3 {
                    position: absolute;
                    left: -14px;
                    top: 15px;
                    background: #fff;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    z-index: 2;
                    border: 4px solid rgba(67,166,73,1.00);
                }

                .section-discover-tour-content .module .circle3.done {
                    background: rgba(67,166,73,1.00);
                    border: 2px solid rgba(67,166,73,1.00);
                }

                .section-discover-tour-content .btn1 {
                    background: rgba(67,166,73,1.00);
                    border-radius: 0;
                    color: #fff;
                    font-weight: 700;
                    font-size: 18px;
                    padding: 15px 40px;
                }

                .section-discover-tour-content .btn1:hover {
                    background: rgba(67,166,73,0.7);
                }

                .section-discover-tour-content .btn2 {
                    background: #fff;
                    border: 3px solid rgba(67,166,73,1.00);
                    border-radius: 0;
                    color: rgba(67,166,73,1.00);
                    font-weight: 700;
                    font-size: 18px;
                    padding: 14px 40px;
                }

                .section-discover-tour-content .btn2:hover {
                    background: rgba(67,166,73,0.7);
                    color: #fff;
                }

                .section-discover-tour-content .text-link1 {
                    color: #0f51b9;
                    font-size: 18px;
                    cursor: pointer;
                    text-decoration: none !important;
                }

                .section-discover-tour-content .text-link2 {
                    color: #232323;
                    cursor: pointer;
                    text-decoration: none !important;
                }

                .section-discover-tour-content .text-link3 {
                    color: #0f51b9;
                    cursor: pointer;
                    text-decoration: none !important;
                }

                @media (min-width: 1200px) {

                    .section-discover-tour-content .module.take-tour-btn-container p {
                        padding-left: 30px;
                    }

                }

                @media (max-width: 767.98px) {

                    .section-discover-tour-content {
                        font-size: 14px;
                        line-height: normal;
                    }

                    .section-discover-tour-content .container {
                        padding-left: 15px;
                    }

                    .section-discover-tour-content .module {
                        padding-left: 20px;
                        position: relative;
                    }

                    .section-discover-tour-content .module h3 {
                        font-size: 18px;
                    }

                    .section-discover-tour-content .module h4 {
                        font-size: 16px;
                    }

                    .section-discover-tour-content .module .box1 {
                        height: 60px;
                    }

                    .section-discover-tour-content .module .circle1 {
                        left: -14px;
                        top: 30px;
                    }

                    .section-discover-tour-content .module .circle2 {
                        left: -14px;
                        top: 30px;
                    }

                    .section-discover-tour-content .module .circle3 {
                        left: -14px;
                        top: 5px;
                    }

                    .section-discover-tour-content .module.take-tour-btn-container {
                        padding-left: 60px;
                    }

                    .section-discover-tour-content .btn1 {
                        font-size: 14px;
                        padding: 15px 30px;
                    }

                    .section-discover-tour-content .btn2 {
                        font-size: 14px;
                        padding: 12px 30px;
                    }

                    .section-discover-tour-content .text-link1 {
                        font-size: 14px;
                    }

                }

            `}</style>
        </>
    );
}

export default TourContent;